import CatRootModulePropertiesPane from '../_CAT_ROOT_MODULE/CatRootModulePropertiesPane.jsx'

export default function PropertiesPaneCatRootFm(props) {
    return (
        <CatRootModulePropertiesPane
            {...props}
        />
    )
}
